import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { useCallback } from "react";
import TranslateFile from "../../../../Loc/TranslateFile";

const TextAreaInput = ({
  name,
  id,
  label,
  value,
  handleChange,
  placeholder,
  required,
  disabled,
  errorMessage,
  rows,
  onClick,
  maxCharacter
}) => {

  const [isFocused, setIsFocused] = useState(false);
  const maxCharacters = maxCharacter?maxCharacter: 2000;
  const hasError = !!errorMessage[name];
  const currentLang = TranslateFile()


  // Known compound emojis that require special handling
  const compoundEmojis = ["🤷‍♀️", "🤷‍♂️"];

  // Regex to match both single emojis and compound emojis with ZWJ
  const emojiRegex =
    /(\p{Extended_Pictographic}(\u200D\p{Extended_Pictographic})*)/gu;

  // Function to count emojis as single units and other characters normally
  const getDisplayLength = useCallback(
    (text) => {
      // Count compound emojis explicitly
      let compoundEmojiCount = 0;
      compoundEmojis?.forEach((emoji) => {
        const compoundRegex = new RegExp(emoji, "g");
        const match = text?.match(compoundRegex);
        if (match) {
          compoundEmojiCount += match?.length;
          // Remove matched compound emojis from text to prevent double-counting
          text = text?.replace(compoundRegex, "");
        }
      });

      // Count remaining emojis with regex
      const matches = text?.match(emojiRegex);
      let emojiCount = matches ? matches?.length : 0;

      // Calculate non-emoji characters
      let nonEmojiText = text?.replace(emojiRegex, "").normalize("NFC").trim();
      let nonEmojiCount = nonEmojiText?.length;

      // Total count: compound emojis + other emojis + non-emoji characters
      return compoundEmojiCount + emojiCount + nonEmojiCount;
    },
    [] // Add any dependencies required
  );




  return (
    <div>
      {label?.trim()?.length > 0 && <label
        className="form-check-label fs-5 form-label-custom-visible"
      >
        {label} {required && <span className="mandatory">*</span>}
      </label>}
      <div className="position-relative">
        <textarea
          name={name}
          id={id}
          inputMode="none"
          className={`form-control fs-5`} // Add 'is-invalid' if there's an error
          style={{
            borderColor: hasError ? "#c8605e" : undefined,
            boxShadow: isFocused
              ? hasError
                ? "0 0 5px 1px #c8605e"
                : "0 0 5px 1px #aaa" // Apply regular shadow on focus
              : "none", // No shadow if not focused
            resize: "none", // Disable resizing
          }}
          value={value}
          onFocus={() => setIsFocused(true)} // Set focus state to true on focus
          onBlur={() => setIsFocused(false)} // Set focus state to false on blur
          placeholder={placeholder}
          //  onChange={(e) => handleChange(e)}
          onClick={onClick}
          required={required}
          autoComplete="off"
          maxLength={maxCharacters}
          disabled={disabled}
          rows={3} // Add rows prop for textarea
        />
        <div className="character-count">
          {maxCharacters - getDisplayLength(value)} {currentLang?.Characters_Left}
        </div>
        {hasError && (
          <div className="text-danger-new fw-700 fs-6 mt-1 position-absolute">
            {errorMessage[name]}
          </div>
        )}
      </div>
    </div>
  );
};

TextAreaInput.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.object,
  rows: PropTypes.number, // Prop for controlling the number of rows
};

TextAreaInput.defaultProps = {
  placeholder: "",
  required: false,
  disabled: false,
  id: "",
  errorMessage: {},
  rows: 3, // Default to 3 rows
};

export default memo(TextAreaInput);
